<template>
  <div :class="$style.root">
    <LayoutSingleTypeHeadingComponent
      :pageData="pageData"
      routeName="fellows"
    />

    <LayoutGridComponent
      :class="$style.items"
      v-if="currentParticipantEntries?.length || upcomingParticipantEntries?.length"
    >
      <SharedFellowThumbnailContainerComponent
        v-if="currentParticipantEntries?.length"
        v-for="participant in currentParticipantEntries"
        :key="participant.id"
        status="current"
      >
        <SharedThumbnailFellowComponent :data="participant" />
      </SharedFellowThumbnailContainerComponent>

      <SharedFellowThumbnailContainerComponent
        v-if="upcomingParticipantEntries?.length"
        v-for="participant in upcomingParticipantEntries"
        :key="participant.id"
        status="upcoming"
      >
        <SharedThumbnailFellowComponent :data="participant" />
      </SharedFellowThumbnailContainerComponent>
    </LayoutGridComponent>

    <SharedFellowThumbnailContainerComponent
      v-if="pastParticipantEntries?.length"
      status="past"
      :count="pastParticipantEntries?.length"
      :class="$style.items"
    >
      <LayoutGridComponent>
        <SharedThumbnailFellowComponent
          v-for="participant in pastParticipantEntries"
          :key="participant.id"
          :data="participant"
        />
      </LayoutGridComponent>
    </SharedFellowThumbnailContainerComponent>

  </div>
</template>

<script setup>
const nuxtApp = useNuxtApp()
const routeName = computed(() => {
  return nuxtApp.$getRouteBaseName()
})

const props = defineProps({
  pageData: Object
})

const localizedData = computed(() => {
  return i18nGetLocalizedData(baseStrapiGetAttributes(props?.pageData))
})

const currentParticipantEntries = computed(() => {
  return localizedData?.value?.current_participant_entries?.data
})

const upcomingParticipantEntries = computed(() => {
  return localizedData?.value?.upcoming_participant_entries?.data
})

const pastParticipantEntries = computed(() => {
  return localizedData?.value?.past_participant_entries?.data
})
</script>

<style module>
.root {
  display: grid;
  grid-row-gap: var(--unit--vertical--sextuple);
}

.items {
  padding: 0 var(--unit--horizontal--tripple);
}
</style>
